export function sleep(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}

export function randomDelay(min = 200, max = 600) {
  return sleep(Math.floor(Math.random() * (max - min)) + min);
}
